import { Card, Flex, Form, Typography } from "antd";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { observer } from "mobx-react-lite";
import { ReactNode, useEffect } from "react";

import { DefaultInput } from "ui";

type Props = {
  walletAddress: string | undefined;
  name: string;
  title: string | ReactNode;
  maxLength?: number;
};
export const CheckWalletInput = observer(({ walletAddress, name, title, maxLength = 100 }: Props) => {
  const form = Form.useFormInstance();

  const getDefaultValue = () => {
    if (!walletAddress) return "";
    return `${walletAddress.slice(0, -4)}****`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    const baseValue = walletAddress?.slice(0, -4);
    const baseLength = baseValue?.length ?? 0;
    const lastFour = inputValue.slice(baseLength, baseLength + 4);
    form.setFieldValue(name, baseValue + lastFour);
  };

  useEffect(() => {
    if (walletAddress) {
      form.setFieldValue(name, getDefaultValue());
    }
  }, [walletAddress]);

  return (
    <Card className="card-not-shadow border-tertiary">
      <Flex vertical gap="small">
        {typeof title === "string" ? (
          <Typography.Title level={2} className="text-center">
            {title}
          </Typography.Title>
        ) : (
          title
        )}

        <Form.Item name={name} validateDebounce={FORM_VALIDATION_DEBOUNCE}>
          <DefaultInput placeholder="Введите последние 4 символа" maxLength={maxLength} onChange={handleChange} />
        </Form.Item>
      </Flex>
    </Card>
  );
});
